import http from 'hub-http/clients/apiClient';
const DEALS_URI = '/deals/v2/deals';
const CRM_SEARCH_BETA_URI = '/crm-search/search/beta';
const FORECAST_SEARCH_URI = '/forecasting/v1/search/deals';
import { DEAL_OBJECT_ID, DEAL_PROPERTIES, SEARCH_OPERATORS } from '../constants/CrmSearchConstants';
import { EARLY_REQUESTER_KEYS } from '../constants/EarlyRequesterKeys';
import { queryQuickFetch } from './earlyRequestHelper';
// TODO: Type updateDeals payload
export const updateDeals = data => http.put(`${DEALS_URI}/batch`, {
  data,
  headers: {
    'X-Properties-Source': 'FORECASTING',
    'X-Properties-SourceId': 'DealUpdate'
  }
});

// TODO: Type fetchDealsWithForecastCategories response
export const fetchDealsWithForecastCategories = () => queryQuickFetch(EARLY_REQUESTER_KEYS.DEALS_WITH_FORECAST_CATEGORIES, () => http.post(CRM_SEARCH_BETA_URI, {
  data: {
    objectTypeId: DEAL_OBJECT_ID,
    count: 1,
    requestOptions: {
      properties: [DEAL_PROPERTIES.FORECAST_CATEGORY]
    },
    filterGroups: [{
      filters: [{
        property: DEAL_PROPERTIES.FORECAST_CATEGORY,
        operator: SEARCH_OPERATORS.HAS_PROPERTY
      }]
    }]
  }
}));
export const fetchDealsRequest = data => http.post(FORECAST_SEARCH_URI, {
  data
});